// 基准大小
const baseSize = 16; // 设置 rem 函数
function setRem() {
  // document.documentElement.style.fontSize = 'initial'//自定义设置响应式不生效，initial为默认16px，可根据需求调节
  if (document.body.clientWidth < 768) {
    const scale = document.documentElement.clientWidth / 375; //手机端 375
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + "px";
  } else {
    const scale = document.documentElement.clientWidth / 1920; //pc端，可根据需求调整
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + "px";
  }
} // 初始化
setRem(); // 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};